import "core-js/modules/es6.array.find.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import TagList from 'src/store/models/TagList';
import Tag from 'src/store/models/Tag';
import { dialog } from 'boot/mixins';
import { colorUtils } from 'src/mixins/colors-utils';
import { cloneDeep, each, findIndex } from 'lodash';
export default {
  mixins: [dialog, colorUtils],
  components: {
    TeDialog: TeDialog
  },
  props: ['tag-list-id'],
  data: function data() {
    return {
      tab: 'info',
      isDirty: false,
      myTagList: null,
      loading: false
    };
  },
  watch: {
    myTagList: {
      deep: true,
      handler: function handler(val, oldVal) {
        if (!this.isDirty && oldVal) {
          this.isDirty = true;
        }
      }
    }
  },
  computed: {
    tagList: function tagList() {
      return TagList.query().where('account_id', this.me.account_id).withAll().find(this.tagListId);
    }
  },
  methods: {
    addNewTag: function addNewTag() {
      this.myTagList.tags.unshift({
        name: null
      }); // this.$refs.scrollArea.setScrollPosition(0)
    },
    markForDeletion: function markForDeletion(tag, index) {
      if (tag.tag_id) {
        tag.delete = true;
      } else {
        this.myTagList.tags.splice(index, 1);
      }
    },
    deletedTagList: function deletedTagList() {
      this.hide();
    },
    undoDeletion: function undoDeletion(tag, index) {
      tag.delete = false;
    },
    show: function show() {
      var _this = this;

      this.$refs.dialog.show();

      if (this.tagListId) {
        this.loading = true;
        TagList.api().get('/tag-lists/' + this.tagListId).finally(function (response) {
          _this.initData();

          _this.loading = false;
        });
      } else {
        this.initData();
        this.loading = false;
      }
    },
    initData: function initData() {
      var _this2 = this;

      if (this.tagList) {
        var myTagList = cloneDeep(this.tagList);
        each(myTagList.tags, function (tag) {
          tag.delete = false;
        });
        this.myTagList = myTagList;
      } else {
        this.myTagList = {
          name: null,
          color: this.getRandomColor(),
          tags: []
        };
      }

      this.$nextTick(function () {
        _this2.isDirty = false;
      });
    },
    validateInputs: function validateInputs() {
      if (this.myTagList.tags) {
        var deletedTags = 0;
        this.myTagList.tags = this.myTagList.tags.filter(function (tag) {
          return tag.name && tag.name.length > 0;
        });
        deletedTags = this.myTagList.tags.filter(function (tag) {
          return tag.delete === true;
        });

        if (deletedTags.length > 0) {
          this.openDialog('TagDeleteDialog', {
            tagCount: deletedTags.length,
            confirm: this.save
          });
        } else {
          this.save();
        }
      } else {
        this.save();
      }
    },
    save: function save() {
      var _this3 = this;

      this.loading = true;

      if (this.tagListId) {
        TagList.api().put('/tag-lists/' + this.tagListId, {
          name: this.myTagList.name,
          color: this.myTagList.color,
          text_color: this.myTagList.text_color ? this.myTagList.text_color : '#000',
          tags: this.myTagList.tags
        }).then(function (response) {
          Tag.delete(function (tag) {
            return findIndex(_this3.myTagList.tags, {
              tag_id: tag.tag_id,
              delete: true
            }) > -1;
          });

          _this3.initData();

          _this3.$root.$emit('refresh-tags');

          _this3.hide();

          _this3.loading = false;

          _this3.$q.notify({
            message: _this3.$t('general.has_been_updated', {
              el: _this3.myTagList.name
            }),
            type: 'positive'
          });
        }).catch(function () {}).finally(function () {
          _this3.loading = false;
        });
      } else {
        TagList.api().post('/tag-lists', {
          name: this.myTagList.name,
          color: this.myTagList.color,
          text_color: this.myTagList.text_color ? this.myTagList.text_color : '#000',
          tags: this.myTagList.tags
        }).then(function (response) {
          _this3.$root.$emit('refresh-tags');

          _this3.hide();

          _this3.$q.notify({
            message: _this3.$t('components.tagListDialog.tag_list_created', {
              name: _this3.myTagList.name
            }),
            type: 'positive'
          });
        }).catch(function () {}).finally(function () {
          _this3.loading = false;
        });
      }
    }
  }
};